let stage: string | undefined;
let stageConfig;

function getConfig(stage:string | undefined){
    if (stage === 'prod') return {
        poolId: "ap-southeast-2_zP4RU1L4P",
        webClientId: "gddhfupimcavon486pjkm8r6n",
        authDomain: "auth.frg-esports.au",
        redirectSignIn: "https://frg-esports.au/signin",
        redirectSignOut: "https://frg-esports.au",
    }
    if (stage === 'dev') return {
        poolId: "ap-southeast-2_t5MiZRIVv",
        webClientId: "15eh62c1oh0uirc9oc0t42s4bv",
        authDomain: "auth.dev.frg-esports.au",
        redirectSignIn: "https://dev.frg-esports.au/signin",
        redirectSignOut: "https://dev.frg-esports.au",
    }
    if (stage === 'local') return {
        poolId: "ap-southeast-2_t5MiZRIVv",
        webClientId: "15eh62c1oh0uirc9oc0t42s4bv",
        authDomain: "auth.dev.frg-esports.au",
        redirectSignIn: "https://localhost:3000/signin",
        redirectSignOut: "https://localhost:3000",
    }
    throw new Error()
}

try {
    stage = process.env.STAGE
    stageConfig = getConfig(stage)
} catch(error) {
    throw new Error(`Unable to get STAGE environment variable. Have you run 'export STAGE="dev"' to set the stage environment variable? ${error}`)
}

export const amplifyConfig = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": stageConfig.poolId,
    "aws_user_pools_web_client_id": stageConfig.webClientId,
    "oauth": {
        "domain": stageConfig.authDomain,
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": stageConfig.redirectSignIn,
        "redirectSignOut": stageConfig.redirectSignOut,
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "GIVEN_NAME",
        "FAMILY_NAME",
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 6,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
}

